import { Link } from "react-router-dom";

const PaymentCancel = () => (
  <div className="grain min-h-screen flex items-center justify-center" data-testid="payment-cancel-page">
    <div className="text-center max-w-md px-6">
      <div className="font-display text-4xl mb-3">Payment cancelled.</div>
      <div className="text-[#a39797] mb-8">No charge made. Your case stays unopened.</div>
      <Link to="/checkout" className="btn-primary" data-testid="restart-checkout">
        Try again
      </Link>
    </div>
  </div>
);

export default PaymentCancel;
